import React, { useState, useCallback } from "react";
import "./style.less";
import { Menu, Icon } from "semantic-ui-react";
import { Link } from "react-router-dom";
import { useRouteMatch } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logoutUser } from "../../../redux/geofence/actions";

function LeftMenu() {
  const [expanded, setExpanded] = useState(false);
  const match = useRouteMatch("/city/:cityName/");
  const rmBuddyRouteMatch = useRouteMatch("/rmBuddies/:warehouseId/");
  const showRmbuddiesCta = useRouteMatch("/rmBuddies/");
  let cityName;
  if (match && match.params) {
    cityName = match.params.cityName;
  }
  let warehouseId = "";
  if (rmBuddyRouteMatch && rmBuddyRouteMatch.params) {
    warehouseId = rmBuddyRouteMatch.params.warehouseId;
  }
  const dispatch = useDispatch();
  const toggleMenu = () => {
    setExpanded(!expanded);
  };
  const userAuthenticated = useSelector(
    ({ geofence }) => geofence.userAuthenticated
  );
  const logoutCtaClickHandler = useCallback(() => {
    dispatch(logoutUser());
  }, [dispatch]);

  return (
    <div className={`LeftMenu ${expanded ? "expanded" : ""}`}>
      <div onClick={toggleMenu} className="MenuExpander">
        <div>
          <Icon name="bars" /> Menu
        </div>
      </div>
      <Menu icon className="LeftMenuBox" vertical borderless>
        <Link to={cityName ? `/city/${cityName}/geofences` : "/"}>
          <Menu.Item
            className={
              window.location.pathname.includes("/city") ? "active" : null
            }
          >
            <div>
              <div>
                <Icon name="map outline"></Icon> Maps
              </div>
            </div>
          </Menu.Item>
        </Link>
        <Link to={warehouseId ? `/rmBuddies/${warehouseId}/` : "/rmBuddies/"}>
          <Menu.Item
            className={
              window.location.pathname.includes("/rmBuddies") ? "active" : null
            }
          >
            <div>
              <div>
                <Icon name="users"></Icon> RM Buddies
              </div>
            </div>
          </Menu.Item>
        </Link>
      </Menu>
      {userAuthenticated && (
        <div onClick={logoutCtaClickHandler} className="logoutCta">
          <div>
            <div className="logoutCtaContent">
              <div>
                <Icon name="power off" />
              </div>
              Log out
            </div>
          </div>
        </div>
      )}
      {match &&
      !match.url.includes("/create") &&
      match.url.includes("/city") ? (
        <div className="addCta">
          <div>
            <Link to={`${match.url}/geofences/add`}>
              <div className="addCtaContent">
                <div>
                  <Icon name="add" />
                </div>
                Create new geofence
              </div>
            </Link>
          </div>
        </div>
      ) : null}
      {showRmbuddiesCta ? (
        <div className="addCta">
          <div>
            <Link to={`/rmBuddies/excel/add`}>
              <div className="addCtaContent">
                <div>
                  <Icon name="add" />
                </div>
                Create RmBuddies
              </div>
            </Link>
          </div>
        </div>
      ) : null}
    </div>
  );
}

export default LeftMenu;
